const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the skills search component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Skills} Skills the resource defined to manage Skills
 */
app.directive('skillsSearch', ['Skills', '$q', function (Skills, $q) {
  return {
    restrict: 'E',
    scope: {
      onQuery: '&',
      placeholder: '=',
      conditions: '=',
      clear: '='
    },
    template: require('../../templates/directives/skills-search.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.queries = [];

      self.updateQuery = function() {
        var item = {};

        for (var i = 0; i < self.queries.length; i++) {
          switch (self.queries[i].type) {
            case 'skill':
              item._id = self.queries[i]._id;
              break;
            case 'text':
              item.name = '$regex,2,' + self.queries[i].name + ',i';
              break;
            default:
              break;
          }
        }
        $scope.onQuery({query: item});
      };

      // ------------- start ngTag triggered actions ------------
      self.tagInput = {
        addingTag: function ($tag) {
          if (Object.keys($tag).length === 1 && $tag.name) {
            $tag.text = $tag.name;
            $tag._id = $tag.name + '-text';
            $tag.type = 'text';
          }
          self.queries.splice(0);
          return true;
        },
        addedTag: function ($tag, outside) {
          self.updateQuery();
        },
        removedTag: function ($tag) {
          self.updateQuery();
        },
        clear: function () {
          self.queries.splice(0);
          self.updateQuery();
        }
      };
      // ------------- End ngTag triggered actions ------------

      self.getOptions = function (input) {
        var deferred = $q.defer();
        var query = {
          subresource: '',
          page: 1,
          per_page: 12,
          fields: 'name',
          name: '$regex,2,' + input + ',i'
        };
        if ($scope.conditions) {
          for (var key in $scope.conditions) {
            query[key] = $scope.conditions[key];
          }
        }

        Skills.find(query).$promise
        .then(function (results) {
          var items = [];
          for (var i = 0; i < results.length; i++) {
            if (!results[i] || !results[i].name) {
              continue;
            }
            items.push({
              name: results[i].name,
              text: results[i].name,
              _id: results[i]._id,
              type: 'skill'
            });
          }

          deferred.resolve(items);
        }).catch(function (error) {
          // error messaging
        });

        return deferred.promise;
      };

      $scope.$watch('clear', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          self.tagInput.clear();
          $scope.clear = false;
        }
      });
    }],
    controllerAs: 'skillsearch'
  }
}]);
